import type { SVGProps } from "react";

const SvgCsasLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      style={{
        fill: "#2770f0",
      }}
      transform="scale(1.92)"
      d="M0 0h24v24H0z"
    />
    <path
      d="M12.063 1.5c.631 0 1.262.28 1.682.701.491.491.702 1.052.702 1.753s-.211 1.262-.702 1.753c-.49.49-1.051.701-1.752.701s-1.262-.211-1.753-.701c-.491-.491-.701-1.052-.701-1.753s.21-1.262.701-1.753c.631-.421 1.192-.701 1.823-.701m8.133 9.886V9.843c0-1.402-1.192-2.594-2.594-2.594H6.594C5.192 7.249 4 8.441 4 9.843v5.679h12.269v.841H4v1.543C4 19.308 5.192 20.5 6.594 20.5h11.008c1.402 0 2.594-1.192 2.594-2.594v-5.679H7.926v-.841z"
      style={{
        fill: "#fff",
        fillRule: "nonzero",
      }}
      transform="scale(1.92)"
    />
  </svg>
);
export default SvgCsasLogo;
